<template>
    <div class="container" v-loading="loading">
        <div id="MAPRef" style="width: 100%;height: 100%;"></div>
		<div class="map_info" v-if="info">天地图 | 审图号：GS(2024)0568号 | <label @click="linkTo">湘ICP备2024068008号-1</label></div>
		<div class="search_box" v-if="search">
			<el-input v-model="keywords" style="width: 100%;" placeholder="搜索城市、景点|地点线路请使用列表搜索" clearable
				@keyup.enter.native="handleEnter" @clear="searchClear" @focus="searchFocus">
				<i slot="prefix" class="el-input__icon el-icon-search"></i>
			</el-input>
			<div class="search_list" v-show="searchList.length && searchListShow">
				<div v-for="item in searchList" :key="item.id" class="search_item" @click="selectPoi(item)">
					<div class="item_label">
						<div class="name">{{ item.name }}</div>
						<div class="type">{{ item.typeName }}</div>
					</div>
					<div class="item_address">{{ item.address }}</div>
				</div>
			</div>
			<!-- <div class="city-box">
				<el-popover
					placement="top-start"
					width="350"
					trigger="hover">
					<div class="flex flex-warp" style="gap: 8px;cursor: pointer;">
						<el-tag v-for="item in cityOpitons" :key="item.value" @click="checkCity(item)">{{ item.label }}</el-tag>
					</div>
					<span slot="reference" style="border-bottom: 2px solid #FFF;cursor: pointer;">{{ activeCity.label }}</span>
				</el-popover>
			</div> -->
		</div>
		<!-- <div class="oper-box" v-if="oper">
			<el-dropdown trigger="click" placement="top" :tabindex="9249" v-if="yearList && yearList.length" @command="checkItem">
				<div style="color: #FFF;height: 40px;line-height: 40px;font-weight: 700;margin-right: 15px;font-size: 17px;cursor: pointer;">
					{{ yearList[yearActiveIndex].dicLabel }} <i class="el-icon-arrow-down el-icon--right"></i>
				</div>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item v-for="yItem in yearList" :key="yItem.dicValue" :command="yItem.dicValue">
						{{ yItem.dicLabel }}
					</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
			<div class="oper-item" @click="refresh" alt="主页">
				<i class="icon-admin icon-admin-zhuye"></i>
			</div>
		</div> -->
		<!-- <div class="list_box" v-if="list" :style="{ left: foldState ? '10px' : '-314px' }">
			<slot name="list"></slot>
			<div class="fold_btn" @click="changeFoldState">
				<div v-if="!foldState" class="text-center"><i class="el-icon-d-arrow-right"></i>展开</div>
				<div v-else class="text-center"><i class="el-icon-d-arrow-left"></i>收起</div>
			</div>
		</div> -->
    </div>
</template>
<script>
	import { getJson } from "@/utils/axios.js"
	import { cityList } from "@/utils/cityList"
	import locationIcon from "@/static/icon/dic_local_point_v3.png"
    export default{
		props: {
			markers: {
				type: Array,
				default: []
			},
			drawData: {
				type: Array,
				default: []
			},
			search: {
				type: Boolean,
				default: true
			},
			info: {
				type: Boolean,
				default: true
			},
			oper: {
				type: Boolean,
				default: true
			},
			list: {
				type: Boolean,
				default: true
			},
			yearActiveIndex: {
				type: Number,
				default: 1
			},
			yearList: {
				type: Array,
			}
		},
		watch: {
			markers: {
				handler(){
					this.$nextTick(() => {
						this.createMarkerList(this.markers)
					})
				},
				deep: true,
				immediate: false
			},
			drawData: {
				handler(){
					this.updateDrawData && this.updateDrawData()
				},
				deep: true,
				immediate: false
			}
		},
        data(){
            return{
				loading: true,
				keywords: '',
				searchList: [],
				searchListShow: false,
				foldState: false,
                //天地图客户端KEY
                tdt_client_key: "d31ea8c8b73b25ec71206ebc27c0e389",
                mapRef: null,
                randerTypeKey: 'img_w',
				nowLocation: {
					latitude: 33.765432,
					longitude: 104.293175,
				},
				markerRef: null,
				markerRefs: [],
				drawRefs: [],
				activeCity: { label: '全国', value: ''},
				cityOpitons: cityList
            }
        },
		// 在组件中使用
		computed: {
			isMobile() {
				return window.innerWidth < 768 // 根据实际需求定义断点
			}
		},
        methods: {
			linkTo(){
				window.open('https://beian.miit.gov.cn')
			},
			checkItem(dicValue){
				this.$emit('checkYear', dicValue)
			},
			// 回车搜索
			handleEnter(){
				this.getPoiList(this.keywords)
			},
			// 清空搜索
			searchClear(){
				this.keywords = ''
				this.searchListShow = false
				this.searchList = []
			},
			// 搜索激活
			searchFocus(){
				if(!this.searchListShow && this.searchList.length){
					this.searchListShow = true
				}
			},
			// 选择搜索结果
			selectPoi(item){
				const locationArr = item.lonlat.split(',')
				this.createLocalMarker([ Number(locationArr[1]), Number(locationArr[0]) ], { name: item.name })
				this.searchListShow = false
			},
			// 获取搜索结果
			async getPoiList(keywords){
				getJson('/location/poi', {
					keywords
				}, (res) => {
					const { data } = res
					this.searchList = data.pois || []
					this.searchListShow = true
					if(!data.pois && data.area){
						const locationArr = data.area.lonlat.split(',')
						this.createLocalMarker([ Number(locationArr[1]), Number(locationArr[0]) ], { name: data.area.name })
						return
					}
					if(this.searchList.length <= 0){
						this.$message('没有查询到目标信息');
					}
				})
			},
			async getCityInfo(keywords){
				keywords = keywords === '澳门特别行政区' ? '澳门' : keywords === '香港特别行政区' ? '香港' : keywords
				getJson('/location/poi', {
					keywords
				}, (res) => {
					const { data } = res
					this.searchList = data.pois || []
					this.searchListShow = true
					if(!data.pois && data.area){
						const locationArr = data.area.lonlat.split(',')
						this.createLocalMarker([ Number(locationArr[1]), Number(locationArr[0]) ], { name: data.area.name }, 8, false)
						return
					}
					if(this.searchList.length <= 0){
						this.$message('没有查询到目标信息');
					}
				})
			},
			// 列表折叠
			changeFoldState(){
				this.foldState = !this.foldState
			},
			checkCity(city){
				this.activeCity.label = city.label
				this.activeCity.value = city.value
				this.getCityInfo(city.label)
				this.$emit('changeCity', this.activeCity)
			},
			refresh(){
				this.activeCity = {
					label: '全国', value: ''
				}
				this.mapRef && this.mapRef.setView([ this.nowLocation.latitude, this.nowLocation.longitude ], 5);
				this.$emit('changeCity', this.activeCity)
				this.$emit('home')
			},
			setMapView(lat, lng){
				this.mapRef && this.mapRef.setView([ lat, lng ], 16);
			},
			// 尝试获取用户位置信息
			getUserLocation() {
				if ('geolocation' in navigator) {
					navigator.geolocation.getCurrentPosition(
						(position) => {
							this.nowLocation = {
								latitude: position.coords.latitude,
								longitude: position.coords.longitude
							};

							console.log('this.nowLocation', this.nowLocation);
							// this.mapRef && this.mapRef.setView([ Number(locationArr[1]), Number(locationArr[0]) ], 16);
						},(error) => {
							switch (error.code) {
							case error.PERMISSION_DENIED:
								console.log('您拒绝了位置请求。');
								break;
							case error.POSITION_UNAVAILABLE:
								console.log('位置信息不可用。');
								break;
							case error.TIMEOUT:
								console.log('请求位置信息超时。');
								break;
							case error.UNKNOWN_ERROR:
								console.log('发生未知错误。');
								break;
							}
						}
					)
				}else {
					console.log('您的浏览器不支持位置服务。');
				}
			},
			// 计算区块的重心
			getPolygonAreaCenter(points) {
				let sum_x = 0;
				let sum_y = 0;
				let sum_area = 0;
				let p1 = points[1];
				for (var i = 2; i < points.length; i++) {
					let p2 = points[i];
					let area = this.Area(points[0], p1, p2);
					sum_area += area;
					sum_x += (points[0][0] + p1[0] + p2[0]) * area;
					sum_y += (points[0][1] + p1[1] + p2[1]) * area;
					p1 = p2;
				}
				var xx = sum_x / sum_area / 3;
				var yy = sum_y / sum_area / 3;
				return [xx, yy]
			},
			Area(p0, p1, p2) {
				var area = 0.0;
				area = p0[0] * p1[1] + p1[0] * p2[1] + p2[0] * p0[1] - p1[0] * p0[1] - p2[0] * p1[1] - p0[0] * p2[1];
				return area / 2;
			},
			getArrayDepth(arr){
				if (Array.isArray(arr)) {
					return 1 + Math.max(...arr.map(this.getArrayDepth));
				}
				return 0;
			},
			// 回显坐标翻转
			editLatlngRevers(coordinates){
				const arrayDepth = this.getArrayDepth(coordinates)
				if(arrayDepth == 2){
					return coordinates.map(item => {
					return item.map( cItem => {
						return [ cItem.lat, cItem.lng ]
					})
					})
				}else if(arrayDepth == 1 && coordinates.length > 1){
					return coordinates.map(item => [ item.lat, item.lng ])
				}else if(arrayDepth == 1 && coordinates.length <= 1){
					return coordinates.map(item => [ item.lat, item.lng ])
				}
			},
			// 更新绘制物内容
			updateDrawData(){
				if(!this.mapRef) return
				this.drawData.forEach( item => {
					console.log('item', item);
					
					const drawData = item.mapData
					const coordinates = this.editLatlngRevers(drawData.coordinates);
					const type = drawData.type;
					const iData = item.iData || ''
					
					switch (type) {
						// case "Polygon":
						// 	this.updatePolygon(coordinatesResult, iData);
						// 	this.updateLabel(coordinates, label, iData)
						// 	break;
						case "LineString":
							this.updatePolyline(coordinates, iData);
							// this.createMarker(coordinates[0], iData)
							break;
						// case "Point":
						// 	this.updatePointer(coordinatesResult, label, iData);
						// 	break;
						default:
							return;
					}
				})
			},
			// 更新地图中心点 location：{ lat, lng} isMarker:是否创建标注 markerData：标注数据
			updateMapCenter(location, isMarker, markerData){
				this.mapRef && this.mapRef.setView([ Number(location.lng), Number(location.lat) ], 16);
				if(isMarker){
					this.createMarker([ Number(location.lng), Number(location.lat) ], markerData)
				}
			},
			generateStars(rating, totalStars = 5) {
				// 确保评分在有效范围内
				const validRating = Math.max(0, Math.min(rating, totalStars));
				
				// 生成实心星星
				const filledStars = '★'.repeat(validRating);
				// 生成空心星星
				const emptyStars = '☆'.repeat(totalStars - validRating);
				
				return filledStars + emptyStars;
			},
			createMarkerList(markers){
				if(this.markerRef){
					this.mapRef && this.mapRef.removeLayer && this.mapRef.removeLayer(this.markerRef);
					this.markerRef = null
				}
				if(this.markerRefs.length){
					this.markerRefs.forEach( item => {
						this.mapRef && this.mapRef.removeLayer && this.mapRef.removeLayer(item);
					})
				}
				const L = window.L
				if(!L || !L.marker || !this.mapRef) return
				markers.forEach( item => {
					const customIcon = L.icon({
						// iconUrl: 'https://no924worker.oss-cn-heyuan.aliyuncs.com/common/dic_local_point_v2.gif',
						iconUrl: locationIcon,
						iconSize: [16, 16],
						// iconAnchor: [50, 50],
						// popupAnchor: [0, 0]
						// iconSize: this.isMobile ? [45, 45] : [60, 60],
						// iconAnchor: this.isMobile ? [32, 20] : [20, 40],
						// popupAnchor: this.isMobile ? [0, -25] : [0, -40]
					});
					const markerRef = L.marker( item.location, { icon: customIcon } ).addTo(this.mapRef);
					this.markerRefs.push(markerRef)
					if(!this.isMobile){
						// let htmlContent = ''
						// if(item.hot){
						// 	htmlContent = `
						// 		<div style="text-align:center;">
						// 			<div style="font-size:14px;color: #208FF1;padding: 0 10px;">${item.name || '目标地点'}</div>
						// 			<div style="font-size:12px;color:#FF955C;text-align:center;">热度: ${this.generateStars(item.hot)}</div>
						// 		</div>
						// 	`
						// }else{
						// 	htmlContent = `
						// 		<div style="text-align:center;">
						// 			<div style="font-size:14px;color: #208FF1;padding: 0 10px;">${item.name || '目标地点'}</div>
						// 		</div>
						// 	`
						// }
						// 为标记绑定弹出窗口作为标题
						// markerRef.bindTooltip(htmlContent, { 
						// 	permanent: true,
						// 	direction: 'left',
						// 	className: 'custom-tooltip',
						// 	offset: [-10, -15]
						// }).openTooltip();
					}else{
						markerRef.bindTooltip(`
							<div style="text-align:center;">
								<div style="font-size:12px;color: #208FF1;padding: 0 10px;">${item.name || '目标地点'}</div>
							</div>
						`, { 
							permanent: true,
							direction: 'top',
							className: 'mobile-tooltip',
							offset: [-10, -15]
						}).openTooltip();
					}
					markerRef.addEventListener('click', e => {
						this.$emit("check", item)
					})
				})
			},
			createLocalMarker(centerPoint, data, scale, isMarker){
				if(!window.L) return
				if(this.markerRef){
					this.mapRef && this.mapRef.removeLayer && this.mapRef.removeLayer(this.markerRef);
					this.markerRef = null
				}
				this.mapRef && this.mapRef.setView(centerPoint, scale || 16);
				if(isMarker || isMarker=== undefined){
					this.markerRef = L.marker( centerPoint ).addTo(this.mapRef);
					// 为标记绑定弹出窗口作为标题
					this.markerRef.bindTooltip(`
						<div style="text-align:center">
							<div style="font-size:14px;color: #208FF1;padding: 0 10px;">${data.name || '目标地点'}</div>
						</div>
					`, { 
						permanent: true,
						direction: 'bottom',
						className: 'custom-tooltip',
						offset: [-35, 10]
					}).openTooltip();
				}
			},
			updatePolyline(coordinates, data){
				if(this.drawRefs.length){
					this.drawRefs.forEach( item => {
						this.mapRef.removeLayer(item)
					})
				}
				var polyline = L.polyline( coordinates, {
					color: '#E96725',
					weight: 8,
					lineCap: 'round',
					lineJoin: 'round'
				}).addTo(this.mapRef);
				this.drawRefs.push(polyline)
				this.mapRef.fitBounds( polyline.getBounds(),
					{ maxZoom: 18, minZoom: 5 }
				);
			},
            // 挂载地图底图
			mountedBaseMap() {
				this.$nextTick(() => {
					const L = window.L
					if (!L) return
					let viewUrl = ''
					if (this.randerTypeKey == 'img_w') {
						viewUrl = "http://t4.tianditu.gov.cn/img_w/wmts?" +
							"SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles" +
							"&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=" + this.tdt_client_key;
					} else {
						viewUrl = "http://t4.tianditu.gov.cn/vec_w/wmts?" +
							"SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles" +
							"&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=" + this.tdt_client_key;
					}
					this.viewLayer = L.tileLayer(viewUrl, {
						maxNativeZoom: 18, // 超过图层最大值时的保持比例
						maxZoom: 22, // 允许缩放最大值
						preferCanvas: true,
						opacity: 1,
					}).addTo(this.mapRef);

					// 注记图层 默认添加
					const cvaURL = "http://t0.tianditu.gov.cn/cia_w/wmts?" +
						"SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cia&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles" +
						"&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=" + this.tdt_client_key;
					this.cvaLayer = L.tileLayer(cvaURL, {
						maxNativeZoom: 18,
						maxZoom: 22,
						preferCanvas: true,
						opacity: 1,
					}).addTo(this.mapRef);

					if(this.markers.length){
						this.$nextTick(() => {
							this.createMarkerList(this.markers)
						})
					}
					
					this.loading = false
				})
			},
            // 地图初始化
			initTmap() {
				this.loading = true
				const L = window.L
				let lng = this.nowLocation.longitude;
				let lat = this.nowLocation.latitude;
				this.mapRef = L.map( 'MAPRef', {
					zoomControl: false, // 显示缩放控件
					attributionControl: false, // 显示版权文字
					zoomAnimation: false, // 禁用缩放动画
					markerZoomAnimation: false, // 禁用标记的缩放动画
					minZoom: 3,
				}).setView([lat, lng], this.isMobile ? 4 : 5);
				this.mountedBaseMap()
			},
        },
        mounted() {
			this.getUserLocation()
			if (typeof window.L == 'function') {
				this.initTmap();
			} else {
				// 创建leaflet库
				const leafletScript = document.createElement('script');
				leafletScript.src = `https://unpkg.com/leaflet@1.9.4/dist/leaflet.js`;
				document.body.appendChild(leafletScript);
				leafletScript.onload = this.initTmap.bind(this);
			}
		}
    }
</script>
<style lang="scss" scoped>
	:deep(.mobile-tooltip){
		background: rgba($color: #FFF, $alpha: 0.8);
	}
	:deep(.custom-tooltip) {
		background: rgba($color: #FFF, $alpha: 0.9);
	}
	.container{
		width: 100%;
		height: 100%;
		position: relative;
		overflow: hidden;
		.search_box{
			position: absolute;
			left: 10px;top: 10px;
			z-index: 9249;
			width: 320px;
			.search_list{
				background-color: #FFF;
				margin-top: 5px;
				border-radius: 5px;
				max-height: 400px;
				overflow-y: auto;
			}
			.search_item{
				padding: 5px 10px;
				text-align: left;
				border-bottom: 1px solid #eee;
				cursor: pointer;
				.item_label{
					display: flex;
					justify-content: space-between;
					.name{
						font-size: 14px;
						padding-right: 10px;
					}
					.type{
						background-color: #B7CDF0;
						color: #FFF;
						padding: 0 10px;
						height: 24px;
						line-height: 24px;
						font-size: 13px;
						border-radius: 5px;
					}
				}
				.item_address{
					font-size: 13px;
					color: #666;
				}
			}
			.search_item:hover{
				.name{
					color: #0B57D0;
				}
				.item_address{
					color: #0B57D0;
				}
			}
			.city-box{
				position: absolute;
				right: -190px;top: 2px;
				display: flex;
				color: #FFF;
				padding: 7px 0;
				width: 180px;
				text-align: left;
			}
		}
		.oper-box{
			position: absolute;
			right: 10px;top: 10px;
			z-index: 9248;
			height: 40px;
			border-radius: 5px;
			display: flex;
			justify-content: flex-end;
			.oper-item{
				background-color: #FFF;
				border-radius: 50px;
				width: 40px;height: 40px;
				cursor: pointer;
				text-align: center;
				line-height: 40px;
				transition: 300ms;
			}
			.oper-item:hover{
				transform: scale(1.1);
			}
		}
		.list_box{
			position: absolute;
			left: 10px;top: 70px;
			z-index: 924;
			width: 320px;
			height: calc( 100% - 120px );
			background-color: rgba(15, 88, 181, 0.3);
    		backdrop-filter: blur(8px);
			border-radius: 5px;
			transition: 300ms;
			.fold_btn{
				position: absolute;
				right: -40px;
				top: 50%;
				width: 30px;
				height: 80px;
				margin-top: -40px;
				background-color: #FFF;
				border-radius: 5px;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				cursor: pointer;
				transition: 300ms;
			}
			.fold_btn:hover{
				background-color: rgba(15, 88, 181, 0.8);
				color: #FFF;
			}
		}
	}
	@media (max-width: 767px) {
		.container{
			width: 100%;
			height: 100%;
			position: relative;
			overflow: hidden;
			.search_box{
				position: absolute;
				left: 10px;top: 10px;
				z-index: 9249;
				width: calc( 100% - 20px );
				.search_list{
					background-color: #FFF;
					margin-top: 5px;
					border-radius: 5px;
					max-height: 400px;
					overflow-y: auto;
				}
				.search_item{
					padding: 5px 10px;
					text-align: left;
					border-bottom: 1px solid #eee;
					cursor: pointer;
					.item_label{
						display: flex;
						justify-content: space-between;
						.name{
							font-size: 14px;
							padding-right: 10px;
						}
						.type{
							background-color: #B7CDF0;
							color: #FFF;
							padding: 0 10px;
							height: 24px;
							line-height: 24px;
							font-size: 13px;
							border-radius: 5px;
						}
					}
					.item_address{
						font-size: 13px;
						color: #666;
					}
				}
				.search_item:hover{
					.name{
						color: #0B57D0;
					}
					.item_address{
						color: #0B57D0;
					}
				}
			}
			.oper-box{
				position: absolute;
				right: 10px;top: 60px;
				z-index: 9248;
				// width: 320px;
				height: 40px;
				border-radius: 5px;
				display: flex;
				justify-content: flex-end;
				.oper-item{
					background-color: #FFF;
					border-radius: 50px;
					width: 35px;height: 35px;
					cursor: pointer;
					text-align: center;
					line-height: 35px;
					transition: 300ms;
				}
				.oper-item:hover{
					transform: scale(1.1);
				}
			}
			.list_box{
				position: absolute;
				left: 10px;top: 60px;
				z-index: 924;
				width: 314px;
				height: calc( 100% - 100px );
				background-color: rgba(15, 88, 181, 0.3);
				backdrop-filter: blur(8px);
				border-radius: 5px;
				transition: 300ms;
				.fold_btn{
					position: absolute;
					right: -40px;
					top: 50%;
					width: 30px;
					height: 80px;
					margin-top: -40px;
					background-color: rgba(15, 88, 181, 1);
					color: #FFF;
					border-radius: 5px;
					display: flex;
					flex-direction: column;
					justify-content: center;
					align-items: center;
					cursor: pointer;
					transition: 300ms;
				}
				.fold_btn:hover{
					background-color: rgba(15, 88, 181, 1);
					color: #FFF;
				}
			}
		}
	}


	.map_info{
		position: absolute;
		left: 0;bottom: 0;
		z-index: 924;
		width: 400px;
		background: rgba($color: #FFFFFF, $alpha: 0.8);
		font-size: 12px;
		padding: 6px 0;
		border-radius:  0 5px 0 0;
		text-align: center;
	}
	.map_info label{
		cursor: pointer;
	}
	.map_info label:hover{
		color: #0B57D0;
	}
	@media (max-width: 767px) {
		.map_info {
			width: 100%;
			border-radius: 0;
		}
	}
</style>